'use client';

import { createContext, type PropsWithChildren, useContext } from 'react';

const QuizPlacementContext = createContext<boolean | null>(null);

export type QuizPlacementProviderProps = PropsWithChildren<{ quizzesInWorkflows: boolean }>;

export function QuizPlacementProvider({ quizzesInWorkflows, children }: QuizPlacementProviderProps) {
  return <QuizPlacementContext.Provider value={quizzesInWorkflows}>{children}</QuizPlacementContext.Provider>;
}

// Outside the teacher layout there's no server-read flag, so fall back to the legacy placement; the proxy redirects if that's wrong.
export function useQuizzesInWorkflows(): boolean {
  return useContext(QuizPlacementContext) ?? false;
}
